// extracted by mini-css-extract-plugin
module.exports = {"trustIcon":"TrustIcon_trustIcon__8Vx3u","footer":"TrustIcon_footer__BDWiL","normalFooter":"TrustIcon_normalFooter__jr3_9"};